<div class="py-4 container-fluid erp-leave-import-page">
  <div class="erp-leave-import-page-header">
    <h4 class="mb-0 erp-leave-import-title">
      การจัดการคำขอสอนชดเชย - นำเข้าวันลาจากระบบ ERP
    </h4>
  </div>

  <div class="erp-leave-import-card">
    <div class="erp-leave-import-card-body">
      <div class="erp-leave-import-toolbar" [formGroup]="form">
        <div class="erp-leave-import-filters">
          <div class="erp-leave-import-filter">
            <app-select
              label="เทอมการศึกษา"
              formControlName="academicTerm"
              [options]="academicTermOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="erp-leave-import-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="erp-leave-import-filter">
            <app-select
              label="ปีการศึกษา"
              formControlName="year"
              [options]="yearOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="erp-leave-import-select"
              classes="mb-0"
            ></app-select>
          </div>
        </div>

        <div class="erp-leave-import-buttons">
          <button
            type="button"
            class="btn btn-outline erp-leave-import-outline-button"
            [disabled]="isExporting"
            (click)="onExportExcel()"
          >
            <img src="assets/media/icons/svg/file-down.svg" class="erp-leave-import-toolbar-icon" alt="" aria-hidden="true" />
            <span>ดาวน์โหลดแบบฟอร์ม</span>
          </button>

          <button
            type="button"
            class="btn btn-outline erp-leave-import-outline-button"
            [disabled]="isImporting || isCheckingExistingData"
            (click)="onImport()"
          >
            <img src="assets/media/icons/svg/file-up.svg" class="erp-leave-import-toolbar-icon" alt="" aria-hidden="true" />
            <span>{{ isCheckingExistingData ? 'กำลังตรวจสอบ...' : 'นำเข้าข้อมูล' }}</span>
          </button>
        </div>
      </div>

      <div class="erp-leave-import-tabs" role="tablist" aria-label="ข้อมูลนำเข้าวันลา ERP">
        <button
          type="button"
          class="erp-leave-import-tab"
          [class.active]="activeTab() === 'leave_records'"
          (click)="onTabChange('leave_records')"
        >
          ข้อมูลวันลา ERP
        </button>
        <button
          type="button"
          class="erp-leave-import-tab"
          [class.active]="activeTab() === 'match_results'"
          (click)="onTabChange('match_results')"
        >
          ผลตรวจข้อมูล
        </button>
      </div>

      <ng-template #rowIndexTemplate let-row="row">
        {{ row.sequence ?? row.order }}
      </ng-template>

      <ng-template #teacherInfoTemplate let-row="row">
        <div class="erp-leave-import-teacher-cell">
          <strong>{{ row.full_name }}</strong>
          <span>{{ row.email }}</span>
        </div>
      </ng-template>

      <ng-template #matchCountTemplate let-row="row">
        <span class="erp-leave-import-count-badge erp-leave-import-count-badge-success">
          {{ row.system_matched_request_count }}
        </span>
      </ng-template>

      <ng-template #systemRequestUnmatchedCountTemplate let-row="row">
        <span class="erp-leave-import-count-badge erp-leave-import-count-badge-danger">
          {{ row.system_unmatched_request_count }}
        </span>
      </ng-template>

      <ng-template #systemRequestCountTemplate let-row="row">
        <span class="erp-leave-import-count-badge erp-leave-import-count-badge-neutral">
          {{ row.system_request_count }}
        </span>
      </ng-template>

      <ng-template #importedAtTemplate let-row="row">
        {{ formatDateTime(row.imported_at || row.created_at) }}
      </ng-template>

      <ng-template #leaveDateTemplate let-row="row">
        {{ formatErpDateRange(row) }}
      </ng-template>

      <ng-template #erpLeaveStartDateTemplate let-row="row">
        {{ formatDate(row.erp_leave_start_date) }}
      </ng-template>

      <ng-template #erpLeaveEndDateTemplate let-row="row">
        {{ formatDate(row.erp_leave_end_date) }}
      </ng-template>

      <ng-template #erpSubmittedAtTemplate let-row="row">
        {{ formatDateTime(row.erp_submitted_at) }}
      </ng-template>

      <ng-template #erpLastUpdatedAtTemplate let-row="row">
        {{ formatDateTime(row.erp_last_updated_at) }}
      </ng-template>

      <ng-template #leaveTypeTemplate let-row="row">
        {{ row.leave_type || '-' }}
      </ng-template>

      <ng-template #usageStatusTemplate let-row="row">
        <span
          class="erp-leave-import-status-badge"
          [ngClass]="getIsActiveBadgeClass(row.is_active)"
        >
          {{ formatIsActive(row.is_active) }}
        </span>
      </ng-template>

      <ng-template #teacherActionTemplate let-row="row">
        <div class="erp-leave-import-actions">
          <button
            type="button"
            class="btn erp-leave-import-action-button datatable-view-action-button"
            [disabled]="isLoadingDetail"
            aria-label="ดูรายละเอียดผลตรวจ ERP"
            (click)="openTeacherDetail(row)"
          >
            <img
              src="assets/media/icons/svg/eye.svg"
              class="erp-leave-import-action-icon datatable-view-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </ng-template>

      <ng-template #comparisonIndexTemplate let-row="row">
        <span class="erp-leave-import-comparison-index">{{ row.sequence }}</span>
      </ng-template>

      <ng-template #comparisonSystemRequestTemplate let-row="row">
        <ng-container *ngIf="row.systemRequest as request; else emptyComparisonCell">
          <div class="erp-leave-import-request-line">
            <strong>{{ formatRequestTitle(request) }}</strong>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #comparisonErpRequestTemplate let-row="row">
        <ng-container *ngIf="row.erpRequest as erpRequest; else emptyComparisonCell">
          <div class="erp-leave-import-request-line">
            <strong>{{ formatErpLeaveDate(row) }}</strong>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #comparisonLeaveDateTemplate let-row="row">
        <span class="erp-leave-import-comparison-date">{{ formatLeaveDate(row) }}</span>
      </ng-template>

      <ng-template #comparisonMakeupTeachingTemplate let-row="row">
        <span class="erp-leave-import-makeup-date-time">
          <span>{{ formatMakeupTeachingDate(row) }}</span>
          <span class="erp-leave-import-makeup-time">
            {{ formatMakeupTeachingTimeWithHours(row) }}
          </span>
        </span>
      </ng-template>

      <ng-template #comparisonStatusTemplate let-row="row">
        <span
          class="erp-leave-import-comparison-badge"
          [ngClass]="getComparisonBadgeClass(row.comparisonStatus)"
        >
          {{ row.comparisonLabel }}
        </span>
      </ng-template>

      <ng-template #emptyComparisonCell>
        <span class="erp-leave-import-comparison-empty">-</span>
      </ng-template>

      <div *ngIf="activeTab() === 'leave_records'" class="erp-leave-import-summary-panel">
        <app-datatable
          class="erp-leave-import-leave-record-datatable"
          [datasource]="leaveRecordTableDatasource"
          [columns]="leaveRecordColumns"
          [isLoading]="leaveRecordTableLoading()"
          [limit]="leaveRecordTableDatasource.limit"
          [mode]="datatableColumnMode.force"
          [showOrder]="false"
          [externalSorting]="true"
          (sortChange)="onLeaveRecordSortChange($event)"
        ></app-datatable>

        <app-table-pagination
          [page]="leaveRecordTableDatasource.page"
          [limit]="leaveRecordTableDatasource.limit"
          [total]="leaveRecordTableDatasource.total"
          [totalPage]="leaveRecordTableDatasource.total_page"
          [offset]="leaveRecordTableDatasource.offset"
          [dataLength]="leaveRecordTableDatasource.data.length"
          [pageSizeOptions]="pageSizeOptions"
          ariaLabel="ERP leave records pagination"
          (pageChange)="onLeaveRecordPageChange($event)"
          (limitChange)="onLeaveRecordLimitChange($event)"
        ></app-table-pagination>
      </div>

      <div *ngIf="activeTab() === 'match_results'" class="erp-leave-import-summary-panel">
        <app-datatable
          [datasource]="teacherTableDatasource"
          [columns]="columns"
          [isLoading]="tableLoading()"
          [limit]="teacherTableDatasource.limit"
          [showOrder]="false"
          [externalSorting]="true"
          (sortChange)="onSortChange($event)"
        ></app-datatable>

        <app-table-pagination
          [page]="teacherTableDatasource.page"
          [limit]="teacherTableDatasource.limit"
          [total]="teacherTableDatasource.total"
          [totalPage]="teacherTableDatasource.total_page"
          [offset]="teacherTableDatasource.offset"
          [dataLength]="teacherTableDatasource.data.length"
          [pageSizeOptions]="pageSizeOptions"
          ariaLabel="ERP leave import results pagination"
          (pageChange)="onPageChange($event)"
          (limitChange)="onLimitChange($event)"
        ></app-table-pagination>


      </div>
    </div>
  </div>
</div>

<app-form-import-new
  modalId="erpLeaveImportDataModal"
  title="นำเข้าวันลาจากระบบ ERP"
  dragText="ลากไฟล์ Excel มาวาง หรือคลิกเพื่อเลือกไฟล์"
  helperText="รองรับไฟล์ .xlsx"
  [isSaving]="isImporting"
  (saved)="onImportFile($event)"
></app-form-import-new>

<div
  class="modal fade erp-leave-import-detail-modal"
  id="erpLeaveImportTeacherDetailModal"
  tabindex="-1"
  aria-labelledby="erpLeaveImportTeacherDetailModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content erp-leave-import-summary-content">
      <div class="modal-header erp-leave-import-summary-header">
        <div *ngIf="selectedTeacherSummary as teacher">
          <h4 class="modal-title erp-leave-import-summary-title" id="erpLeaveImportTeacherDetailModalLabel">
            รายละเอียดผลตรวจข้อมูลขอสอนชดเชย {{ teacher.full_name }}
          </h4>
        </div>

        <button type="button" class="btn-close" aria-label="Close" (click)="closeTeacherDetailModal()"></button>
      </div>

      <div class="modal-body erp-leave-import-summary-body" *ngIf="selectedTeacherSummary as teacher">
        <div class="erp-leave-import-summary-metrics">
          <div class="erp-leave-import-summary-metric">
            <span>รายการคำขอทั้งหมด</span>
            <strong>{{ teacher.system_request_count }}</strong>
          </div>
          <div class="erp-leave-import-summary-metric erp-leave-import-summary-metric-success">
            <span>ตรงกัน</span>
            <strong>{{ teacher.matched.length }}</strong>
          </div>
          <div class="erp-leave-import-summary-metric erp-leave-import-summary-metric-danger">
            <span>ไม่ตรงกัน</span>
            <strong>{{ getUnsuccessfulComparisonCount(teacher) }}</strong>
          </div>
        </div>

        <div
          class="erp-leave-import-all-matched"
          *ngIf="teacher.import_unmatched.length === 0 && teacher.system_unmatched.length === 0"
        >
          ข้อมูลตรงกันทั้งหมด
        </div>

        <div class="erp-leave-import-teacher-detail">
          <section class="erp-leave-import-result-section">
            <div class="erp-leave-import-detail-status-tabs" role="tablist" aria-label="สถานะคำขอสอนชดเชย">
              <button
                type="button"
                class="erp-leave-import-detail-status-tab"
                [class.active]="activeDetailStatusTab() === 'approved'"
                (click)="onDetailStatusTabChange('approved')"
              >
                รับรองแล้ว
              </button>
              <button
                type="button"
                class="erp-leave-import-detail-status-tab"
                [class.active]="activeDetailStatusTab() === 'pending'"
                (click)="onDetailStatusTabChange('pending')"
              >
                รอดำเนินการ
              </button>
            </div>
              <div class="erp-leave-import-result-section-header">
              <h6>ผลการเปรียบเทียบ</h6>
            </div>
            <div class="erp-leave-import-comparison-scroll">
              <app-datatable
                *ngIf="isTeacherDetailTableReady(); else comparisonTableLoading"
                class="erp-leave-import-comparison-datatable"
                [datasource]="comparisonTableDatasource"
                [columns]="comparisonColumns"
                [isLoading]="false"
                [limit]="comparisonTableDatasource.limit"
                [showOrder]="false"
                [externalSorting]="false"
                [maxVisibleRows]="comparisonTableDatasource.limit"
              ></app-datatable>
              <ng-template #comparisonTableLoading>
                <div class="erp-leave-import-comparison-loading">
                  กำลังโหลดข้อมูล...
                </div>
              </ng-template>
            </div>
            <app-table-pagination
              [page]="comparisonTableDatasource.page"
              [limit]="comparisonTableDatasource.limit"
              [total]="comparisonTableDatasource.total"
              [totalPage]="comparisonTableDatasource.total_page"
              [offset]="comparisonTableDatasource.offset"
              [dataLength]="comparisonTableDatasource.data.length"
              [pageSizeOptions]="comparisonPageSizeOptions"
              ariaLabel="ERP leave import comparison pagination"
              (pageChange)="onComparisonPageChange($event)"
              (limitChange)="onComparisonLimitChange($event)"
            ></app-table-pagination>
          </section>
        </div>
      </div>

      <div class="modal-footer erp-leave-import-summary-footer">
        <button type="button" class="btn btn-primary erp-leave-import-summary-close" (click)="closeTeacherDetailModal()">
          ปิด
        </button>
      </div>
    </div>
  </div>
</div>

<app-confirm-dialog
  #importSuccessDialog
  modalId="erpLeaveImportSuccess"
  icon="success"
  title="นำเข้าข้อมูลสำเร็จ"
  message="นำเข้าข้อมูลจาก ERP สำเร็จ"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="closeImportSuccessDialog()"
></app-confirm-dialog>

<app-confirm-dialog
  #importExistingDataConfirmDialog
  modalId="erpLeaveImportExistingDataConfirm"
  icon="warning"
  title="พบข้อมูลวันลาในช่วงเวลาการศึกษาปัจจุบันแล้ว"
  message="การนำเข้าใหม่จะล้างข้อมูลวันลาเดิมของช่วงเวลาการศึกษาปัจจุบัน และแทนที่ด้วยข้อมูลจากไฟล์ใหม่ ต้องการดำเนินการต่อหรือไม่"
  cancelText="ยกเลิก"
  confirmText="นำเข้าต่อ"
  (confirmed)="onConfirmImportExistingData()"
></app-confirm-dialog>

<app-confirm-dialog
  #importCheckErrorDialog
  modalId="erpLeaveImportCheckError"
  icon="error"
  title="ไม่สามารถตรวจสอบข้อมูลเดิมได้"
  message="ไม่สามารถตรวจสอบข้อมูลวันลาเดิมในช่วงเวลาการศึกษาปัจจุบันได้ กรุณาลองใหม่อีกครั้ง"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="importCheckErrorDialog.close()"
></app-confirm-dialog>

<app-confirm-dialog
  #exportErrorDialog
  modalId="erpLeaveImportExportError"
  icon="error"
  title="ไม่สามารถดาวน์โหลดแบบฟอร์มได้"
  [message]="exportErrorMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="exportErrorDialog.close()"
></app-confirm-dialog>
